/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/aria-role */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable i18next/no-literal-string */
import { GridCellParams } from '@mui/x-data-grid-pro';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { Box, ClickAwayListener, MenuItem, Select } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import React from 'react';
import WarningIcon from '@mui/icons-material/Warning';
import ArrowIcon from 'app/assets/images/Credentialing/PersonalInfo/arrow.svg';
import { CustomTooltip } from 'app/components/Common/Tooltips';
import { useSelector } from 'react-redux';
import { ILookupState } from 'store/redux-store/lookup/initialState';
import { lookupSelector } from 'store/redux-store/lookup/lookup.selectors';

const useStyles = makeStyles()({
  hidden: {
    display: 'none',
  },
  input: {
    width: '100%',
    height: '30px',
    border: 'none',
    '&:focus': {
      border: '1px dotted gray',
      outline: 'none',
    },
  },
  inputInvalid: {
    color: 'red',
  },
  inputValid: {
    color: '#a3a2a2',
  },
  dropdown: {
    paddingTop: 9,
    height: 36,
    marginTop: 7,
    width: 115,
    fontSize: 'small',
  },
  dropdownStyle: {
    background: '#ebf4fa',
    maxHeight: '350px',
    // width: '200px',
    // height: 0,
  },
});

interface GridDropdownCellProps {
  onEndEdit: ({ value, params }: { value: any; params: GridCellParams }) => void;
  validator?: ({ value, params }: { value: any; params: GridCellParams }) => boolean;
  placeholder?: string;
  mandatory?: boolean;
  editOnSingleClick?: boolean;
  Input?: any;
  dropdownOptions?: any;
  disabled?: boolean;
}

export const GridDropdownCell =
  ({ ...props }: GridDropdownCellProps) =>
  (params: GridCellParams) => {
    return <XGridEditableCellContent params={params} props={props} />;
  };

const XGridEditableCellContent = ({ props, params }: { props: GridDropdownCellProps; params: GridCellParams }) => {
  const { classes, cx } = useStyles();
  const api = useGridApiContext();
  const { onEndEdit, validator, placeholder, mandatory, editOnSingleClick = false,disabled= false } = props;

  const [editing, setEditing] = React.useState<boolean>(false);
  const [editValue, setEditValue] = React.useState<any>(params.value);
  const [valid, setValid] = React.useState<boolean>(true);
  const [firstInteraction, setFirstInteraction] = React.useState<boolean>(true);
  const [states, setStates] = React.useState<any[]>([]);
  const selMasterCopy: ILookupState = useSelector(lookupSelector);
  const [options, setOptions] = React.useState<any[]>([]);

  React.useEffect(() => {
    setEditValue(params.value);
    if (validator && !firstInteraction) {
      setValid(validator({ value: editValue, params: params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.value, validator]);

  React.useEffect(() => {
    if (validator && !firstInteraction) {
      setValid(validator({ value: editValue, params: params }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, params.value, validator]);
  const initializeData = () => {
    switch (params.colDef.field) {
      case 'degree':
        setOptions(selMasterCopy?.degrees);
        break;
      case 'major':
        setOptions(selMasterCopy?.majors);
        break;
      case 'country':
        setOptions(selMasterCopy?.countries);
        break;
      case 'graduatedOnMonth':
        setOptions(selMasterCopy?.graduationMonth);
        break;
      case 'graduatedOnYear':
        setOptions(selMasterCopy?.graduationYear);
        break;
      case 'state':
        setStates(selMasterCopy?.states);
        break;
    }
  };

  const startEditing = React.useCallback(() => {
    initializeData();
    setFirstInteraction(false);
    if (!editOnSingleClick) setEditing(true);
    setTimeout(() => {
      if (editOnSingleClick) setEditing(true);
      document.getElementById(`grid-cell-input-${params.row.id}-${params.colDef.field}`)?.focus();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editOnSingleClick, params.colDef.field, params.row.id]);

  const _onEndEditing = () => {
    if (editing) setEditing(false);
    if (states?.length > 0 && params.colDef.field === 'state') {
      api?.current?.updateRows([
        {
          ...params.row,
          [params.colDef.field]: editValue,
          stateProvinceID: null,
        },
      ]);
      if (editValue !== params.value) onEndEdit({ value: editValue, params: params });
    }
  };

  const onKeyUp = React.useCallback(
    event => {
      if (
        event.keyCode === 13 &&
        document.activeElement?.getAttribute('data-field') === params.field &&
        document.activeElement?.getAttribute('data-rowindex') ===
          `${api?.current?.getRowIndexRelativeToVisibleRows(params.id)}`
      ) {
        startEditing();
      }
    },
    [api, params.field, params.id, startEditing],
  );

  React.useEffect(() => {
    document.addEventListener('keyup', onKeyUp);
    return () => {
      document.removeEventListener('keyup', onKeyUp);
    };
  }, [onKeyUp, params]);

  const onInputChanged = value => {
    setEditValue(value);
  };

  const handleSelect = value => {
    setEditValue(value);
    if (editing) {
      setEditing(false);
      if (params.colDef.field === 'state') {
        api?.current?.updateRows([
          {
            ...params.row,
            [params.colDef.field]: selMasterCopy?.states?.find(x => x.Description == value)?.StateNumber,
            stateProvinceID: selMasterCopy?.states?.find(x => x.Description == value)?.ID,
          },
        ]);
      } else if (params.colDef.field === 'country') {
        const stateObj = selMasterCopy?.states?.find(x => x.ID == params.row.state);
        api?.current?.updateRows([
          {
            ...params.row,
            [params.colDef.field]: value,
            countryId: selMasterCopy?.countries?.find(x => x.Description == value)?.ID,
            state: stateObj ? stateObj?.Description : params.row.state,
          },
        ]);
      } else {
        api?.current?.updateRows([{ ...params.row, [params.colDef.field]: value }]);
      }
      onEndEdit({ value: value, params: params });
      if (validator) {
        setValid(validator({ value: value, params: params }));
      }
    }
    setOptions([]);
    setStates([]);
  };

  return (
    <React.Fragment>
      <ClickAwayListener mouseEvent="onMouseDown" onClickAway={_onEndEditing}>
        <div style={{ width: '100%' }} className={cx({ [classes.hidden]: !editing })}>
          {params.row.country !== 'USA' && params.row.country !== 'Canada' && params.colDef.field == 'state' ? (
            <input
              autoComplete="off"
              id={`grid-cell-input-${params.row.id}-${params.colDef.field}`}
              onChange={event => onInputChanged(event.target.value)}
              value={editValue}
              className={cx(classes.input)}
              onSubmit={_onEndEditing}
              onKeyDown={event => event.stopPropagation()}
              onKeyUp={event => {
                if (event.keyCode === 13) _onEndEditing();
                else if (event.keyCode === 27) {
                  setEditValue(params.value);
                  setEditing(false);
                }
              }}
            />
          ) : (
            <>
              {options?.length > 0 && (
                <Select
                  disableUnderline
                  className={classes.dropdownStyle}
                  labelId="select-filled-label"
                  value={editValue}
                  onChange={event => handleSelect(event.target.value)}
                  IconComponent={props => (
                    <img
                      src={ArrowIcon}
                      alt="arrow"
                      style={{ marginRight: '10px', marginLeft: '10px', marginTop: '8px' }}
                      {...props}
                    />
                  )}
                  inputProps={{ className: classes.dropdown }}
                >
                  {(params.colDef.field === 'degree' ||
                    params.colDef.field === 'major' ||
                    params.colDef.field === 'graduatedOnMonth' ||
                    params.colDef.field === 'graduatedOnYear' ||
                    params.colDef.field === 'country') &&
                    options?.map((x: any, idx: any) => {
                      return (
                        <MenuItem key={idx} value={x?.Description}>
                          {x?.Description ?? ''}
                        </MenuItem>
                      );
                    })}
                </Select>
              )}
              {states?.length > 0 && params.colDef.field === 'state' && (
                <Select
                  disableUnderline
                  className={classes.dropdownStyle}
                  labelId="select-filled-state"
                  value={
                    params.colDef.field === 'state'
                      ? states?.find(x => x.StateNumber === editValue || x.ID === editValue)?.Description
                      : editValue
                  }
                  onChange={event => handleSelect(event.target.value)}
                  IconComponent={props => (
                    <img
                      src={ArrowIcon}
                      alt="arrow"
                      style={{ marginRight: '10px', marginLeft: '10px', marginTop: '8px' }}
                      {...props}
                    />
                  )}
                  inputProps={{ className: classes.dropdown }}
                >
                  {states?.map((x: any, idx: any) => {
                    return (
                      <MenuItem key={idx} value={x?.Description}>
                        {x?.Description ?? ''}
                      </MenuItem>
                    );
                  })}
                </Select>
              )}
            </>
          )}
        </div>
      </ClickAwayListener>

      <Box
        onClick={editOnSingleClick ? startEditing : undefined}
        onDoubleClick={!editOnSingleClick ? startEditing : undefined}
        className={cx({
          [classes.hidden]: editing,
          [classes.inputInvalid]: !valid || params.row[`${params.field}_error`] === true,
        })}
        style={{ width: '100%', minHeight: '20px', pointerEvents: disabled ? "none" : "auto" }}
      >
        {editValue ? (
          params.colDef.field == 'state' && (params.row.country == 'USA' || params.row.country == 'Canada') ? (
            selMasterCopy?.states?.find(x => x.StateNumber == editValue || x.ID == editValue)?.Description
          ) : (
            editValue
          )
        ) : (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            {mandatory && (!validator?.({ value: params.value, params }) || false) && (
              <span style={{ padding: '0px 5px 2px 0px' }}>
                <CustomTooltip tooltipContent={'This field is required'}>
                  <WarningIcon style={{ color: 'red', height: '14px', width: '14px' }} />
                </CustomTooltip>
              </span>
            )}
            <span
              className={cx({
                [classes.inputInvalid]: !valid || params.row[`${params.field}_error`] === true,
                [classes.inputValid]: valid && !params.row[`${params.field}_error`],
              })}
            >{`${placeholder || params.colDef.headerName}`}</span>
          </div>
        )}
      </Box>
    </React.Fragment>
  );
};
